module.exports = __webpack_public_path__ + "img/close.15a5008d.svg";